import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/ics_f_location_pin.svg'
import _imports_1 from '@/app/ui/assets/svg/no-address.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-95440afa")

_pushScopeId("data-v-95440afa")
const _hoisted_1 = {
  key: 0,
  class: "p-4 bg-white rounded-xl border border-gray-lp-1400 flex-col justify-start gap-2 inline-flex",
  "data-testid": "pickup-schedule-config-sidebar-address"
}
const _hoisted_2 = { class: "w-full justify-between items-center inline-flex pb-4" }
const _hoisted_3 = { class: "grow shrink basis-0 text-gray-lp-300 text-base font-semibold font-montserrat" }
const _hoisted_4 = {
  key: 0,
  class: "w-full justify-start items-center gap-2 inline-flex"
}
const _hoisted_5 = { class: "grow shrink basis-0 flex-col justify-start items-start gap-2 inline-flex" }
const _hoisted_6 = { class: "self-stretch justify-between items-center inline-flex" }
const _hoisted_7 = { class: "justify-start items-center gap-2 flex" }
const _hoisted_8 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  alt: "location pin",
  class: "w-5 h-5"
}, null, -1)
const _hoisted_9 = {
  key: 0,
  class: "px-2 bg-gray-lp-200 rounded-full items-center gap-2 flex",
  "data-testid": "pickup-schedule-config-sidebar-address-badge-default"
}
const _hoisted_10 = { class: "text-center text-gray-lp-300 text-sm font-medium font-montserrat" }
const _hoisted_11 = { class: "flex-col justify-start items-start gap-4 flex" }
const _hoisted_12 = { class: "flex-col justify-start items-start gap-1 flex" }
const _hoisted_13 = { class: "text-left" }
const _hoisted_14 = { class: "w-full text-gray-lp-300 text-sm font-semibold font-montserrat" }
const _hoisted_15 = { class: "w-full text-gray-lp-300 text-sm font-normal font-montserrat" }
const _hoisted_16 = { class: "flex-col justify-start items-start gap-1 flex" }
const _hoisted_17 = { class: "w-full text-gray-lp-800 font-montserrat" }
const _hoisted_18 = { class: "w-full text-gray-lp-800 font-montserrat" }
const _hoisted_19 = { class: "w-full justify-start items-end gap-1 inline-flex" }
const _hoisted_20 = { class: "w-full text-gray-lp-800 font-montserrat" }
const _hoisted_21 = {
  key: 1,
  class: "w-full py-4 bg-white rounded-lg border border-gray-lp-1400 flex-col justify-center items-center gap-4 inline-flex",
  "data-testid": "pickup-schedule-config-sidebar-address-empty"
}
const _hoisted_22 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  alt: "no-address",
  class: "h-20"
}, null, -1)
const _hoisted_23 = { class: "flex-col justify-start items-start flex" }
const _hoisted_24 = { class: "text-center text-gray-lp-600 text-base font-normal" }
const _hoisted_25 = { class: "w-full" }
const _hoisted_26 = {
  key: 1,
  class: "w-11/12 py-4 mt-6 bg-white rounded-lg border border-gray-lp-1400 flex-col justify-start gap-2 inline-flex",
  "data-testid": "pickup-schedule-config-sidebar-skeleton"
}
const _hoisted_27 = /*#__PURE__*/_createStaticVNode("<div class=\"w-full justify-between items-center inline-flex border-b pb-4 px-6\" data-v-95440afa><div class=\"grow shrink basis-0\" data-v-95440afa><div class=\"h-5 w-48 bg-gray-200 rounded animate-pulse\" data-v-95440afa></div></div></div><div class=\"w-full justify-start items-center gap-2 inline-flex px-6\" data-v-95440afa><div class=\"grow shrink basis-0 flex-col justify-start items-start gap-2 inline-flex\" data-v-95440afa><div class=\"self-stretch justify-between items-center inline-flex\" data-v-95440afa><div class=\"justify-start items-center gap-2 flex\" data-v-95440afa><div class=\"h-6 w-16 bg-gray-200 rounded animate-pulse\" data-v-95440afa></div><div class=\"h-5 w-32 bg-gray-200 rounded animate-pulse\" data-v-95440afa></div></div></div><div class=\"flex-col justify-start items-start gap-4 flex\" data-v-95440afa><div class=\"flex-col justify-start items-start gap-1 flex\" data-v-95440afa><div class=\"h-4 w-48 bg-gray-200 rounded animate-pulse\" data-v-95440afa></div><div class=\"h-4 w-40 bg-gray-200 rounded animate-pulse\" data-v-95440afa></div></div><div class=\"flex-col justify-start items-start gap-1 flex\" data-v-95440afa><div class=\"h-4 w-48 bg-gray-200 rounded animate-pulse\" data-v-95440afa></div><div class=\"h-4 w-48 bg-gray-200 rounded animate-pulse\" data-v-95440afa></div></div></div><div class=\"w-full justify-start items-end gap-1 inline-flex\" data-v-95440afa><div class=\"h-4 w-4 bg-gray-200 rounded animate-pulse\" data-v-95440afa></div><div class=\"h-4 w-48 bg-gray-200 rounded animate-pulse\" data-v-95440afa></div></div></div></div>", 2)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_LpButton = _resolveComponent("LpButton")!

  return (!_ctx.loading)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode("div", {
          class: ["rounded-xl", [{ 'p-4 border border-gray-lp-1500': _ctx.hasAddress }]]
        }, [
          _createVNode("div", _hoisted_2, [
            _createVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("pickup.scheduleConfig.sidebar.addressTitle")), 1),
            _createVNode(_component_LpButton, {
              title: 
            _ctx.$t(
              _ctx.hasAddress
                ? 'pickup.scheduleConfig.sidebar.changeAddress'
                : 'pickup.scheduleConfig.sidebar.addAddress'
            )
          ,
              "data-testid": "pickup-schedule-config-button-change-address",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.hasAddress ? _ctx.$emit('changeAddress') : _ctx.$emit('addAddress'))),
              textSize: '14px',
              textColor: 'red-lp-2400',
              fontWeight: 'semibold',
              tight: "",
              flat: ""
            }, null, 8, ["title"])
          ]),
          (_ctx.hasAddress)
            ? (_openBlock(), _createBlock("div", _hoisted_4, [
                _createVNode("div", _hoisted_5, [
                  _createVNode("div", _hoisted_6, [
                    _createVNode("div", _hoisted_7, [
                      _hoisted_8,
                      (_ctx.address?.pcaIsDefault)
                        ? (_openBlock(), _createBlock("div", _hoisted_9, [
                            _createVNode("div", _hoisted_10, _toDisplayString(_ctx.$t("pickup.scheduleConfig.sidebar.defaultBadge")), 1)
                          ]))
                        : _createCommentVNode("", true),
                      _createVNode("div", {
                        class: "text-gray-lp-300 text-sm font-bold font-montserrat",
                        title: _ctx.address?.pcaName
                      }, _toDisplayString(_ctx.formattedAddressName), 9, ["title"])
                    ])
                  ]),
                  _createVNode("div", _hoisted_11, [
                    _createVNode("div", _hoisted_12, [
                      _createVNode("div", _hoisted_13, [
                        _createVNode("span", _hoisted_14, _toDisplayString(_ctx.address?.pcaPicName), 1),
                        _createVNode("span", _hoisted_15, " • " + _toDisplayString(_ctx.address?.pcaPhoneNumber), 1)
                      ]),
                      _createVNode("div", _hoisted_16, [
                        _createVNode("div", _hoisted_17, _toDisplayString(_ctx.address?.pcaDistrictName), 1),
                        _createVNode("div", _hoisted_18, _toDisplayString(_ctx.address?.pcaAddress), 1)
                      ])
                    ]),
                    _createVNode("div", _hoisted_19, [
                      _createVNode("div", _hoisted_20, _toDisplayString(_ctx.$t("pickup.scheduleConfig.sidebar.coordinatesLabel")) + " " + _toDisplayString(_ctx.address?.pcaLatlon), 1)
                    ])
                  ])
                ])
              ]))
            : (_openBlock(), _createBlock("div", _hoisted_21, [
                _hoisted_22,
                _createVNode("div", _hoisted_23, [
                  _createVNode("div", _hoisted_24, _toDisplayString(_ctx.$t("pickup.scheduleConfig.sidebar.empty")), 1)
                ])
              ]))
        ], 2),
        _createVNode("div", _hoisted_25, [
          _createVNode(_component_LpButton, {
            title: _ctx.$t('pickup.scheduleConfig.sidebar.saveSchedule'),
            isWidthFull: true,
            color: "red-lp-2400",
            textColor: "white",
            disabled: !_ctx.canSubmit,
            loading: _ctx.isSubmitting,
            "data-testid": "pickup-schedule-config-button-save-schedule",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('submit')))
          }, null, 8, ["title", "disabled", "loading"])
        ])
      ]))
    : (_ctx.loading)
      ? (_openBlock(), _createBlock("div", _hoisted_26, [
          _hoisted_27
        ]))
      : _createCommentVNode("", true)
})